export default {
  state: {
    newCardInfra: {
      flags: ['Visa', 'Mastercard', 'Amex', 'Diners', 'Elo', 'Alelo', 'Sodexo', 'Hipercard', 'Aura'],
      inputs: [
        {
          display: 'Numero do cartão',
          placeHolder: 'Nº do cartão',
          type: 'text',
          required: true,
          format: 'cardNumber'
        },
        {
          display: 'Nome do titular',
          placeHolder: 'Nome do titular',
          type: 'text',
          required: true
        },
        {
          display: 'Data de Validade',
          placeHolder: 'Validade',
          type: 'text',
          required: true,
          half: true,
          format: 'cardDate'
        },
        {
          display: 'Cód. de Segurança',
          placeHolder: 'CVV',
          type: 'text',
          required: true,
          half: true,
          format: 'cardCVV'
        }
      ]
    },
    pixRecharge: {
      qrcode: '',
      pixTimeout: 0
    }
  },
  mutations: {
    closePayMethodModal  (state) {
      state.payMethodModal.isVisible = false
    },
    setPixRechargeInfo (state, data) {
      console.log('setPixRechargeInfo', data)
      state.pixRecharge.qrcode = data.qrcode
      state.pixRecharge.pixTimeout = data.pixTimeout
    }
  },
  actions: {
    closePayMethodModal ({ commit }) {
      commit('closePayMethodModal')
    },
    setPixRechargeInfo ({ commit }, data) {
      commit('setPixRechargeInfo', data)
    }
  },
  getters: {
    newCardInfra: (state) => state.newCardInfra,
    pixRechargeInfo: (state) => state.pixRecharge
  }
}
